import React from "react";
import "bulma/css/bulma.min.css";
import { COMBINED_HAZARD_LEGEND } from "./sidepane/CombinedHazard";

// Custom legend, same pattern as NDVILegend -- the combined hazard layer is
// served straight from a TiTiler COG (no GeoServer WMS GetLegendGraphic to
// pull from), so its 9-class palette is rendered directly instead.
const CombinedHazardLegend = ({ title }) => (
  <div className="box" style={{ display: "flex", flexDirection: "column", gap: "4px" }}>
    <p className="is-size-7 has-text-weight-semibold">{title}</p>
    {COMBINED_HAZARD_LEGEND.map(({ color, label }) => (
      <div key={color} style={{ display: "flex", alignItems: "center", gap: "6px" }}>
        <div style={{ width: "14px", height: "14px", backgroundColor: color, border: "1px solid #ccc" }} />
        <span className="is-size-7">{label}</span>
      </div>
    ))}
  </div>
);

export default CombinedHazardLegend;
